
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

interface SignUpBenefitsCardProps {
  onSignUp: () => void;
}

const SignUpBenefitsCard = ({ onSignUp }: SignUpBenefitsCardProps) => {
  return (
    <Card className="bg-muted/40 border-dashed">
      <CardHeader>
        <CardTitle className="text-xl">What you'll get by signing up</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          <li className="flex items-start">
            <Check className="h-5 w-5 text-primary mr-2 mt-0.5" />
            <span>Save all your refund requests and access them anytime</span>
          </li>
          <li className="flex items-start">
            <Check className="h-5 w-5 text-primary mr-2 mt-0.5" />
            <span>Manage conversations with sellers and get AI-powered response suggestions</span>
          </li>
          <li className="flex items-start">
            <Check className="h-5 w-5 text-primary mr-2 mt-0.5" />
            <span>Multiple tone options and personalized refund requests</span>
          </li>
          <li className="flex items-start">
            <Check className="h-5 w-5 text-primary mr-2 mt-0.5" />
            <span>Generate chargeback reports if sellers refuse cooperation</span>
          </li>
        </ul>
        
        <Button 
          className="w-full mt-6"
          onClick={onSignUp}
        >
          Sign Up for Free
        </Button>
      </CardContent>
    </Card>
  );
};

export default SignUpBenefitsCard;
